import { HeaderButton } from "components/layout/button";
import { Credits } from "components/layout/credits";
import paths from "routes/paths";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import { NAV_MAIN } from "./const";
import css from "./index.module.scss";
import { NavItem } from "./nav-item";
import { UserMenu } from "./user-menu";

export const SidebarInner = () => {
  const isLoggedIn = useAppSelector(authNewSelectors.loggedInGet);

  return (
    <div className={css.sidebarInner}>
      {isLoggedIn && (
        <div className={css.credits}>
          <Credits />
        </div>
      )}
      <div className={css.navMain}>
        {NAV_MAIN.map((i) => (
          <NavItem item={i} key={i.label} />
        ))}
      </div>
      <div className={css.bottom}>
        {isLoggedIn ? (
          <UserMenu />
        ) : (
          <>
            <HeaderButton
              className={css.bottomAddCredits}
              to={paths.purchase()}
            >
              Add Credits
            </HeaderButton>
            <HeaderButton secondary to={paths.authLogin()}>
              Login
            </HeaderButton>
          </>
        )}
      </div>
    </div>
  );
};
